import { ref, computed } from 'vue';

const checkSourceMaster = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('source') === 'master';
};

const showJncyLayout = ref(checkSourceMaster());

const setJncyLayout = (show: boolean) => {
  showJncyLayout.value = show;
};

/** 资源 type===1（技能大师/企业课等）时切换为 Jncy 头尾布局 */
export const enableJncyLayoutByResourceType = (type: number | string | undefined | null) => {
  if (Number(type) === 1) {
    setJncyLayout(true);
  }
};

export const useJncyLayout = () => {
  return {
    showJncyLayout: computed(() => showJncyLayout.value),
    setJncyLayout,
    enableJncyLayoutByResourceType,
  };
};
